export const SETUP_LOAD = 'SETUP_LOAD';
export const SETUP_RELOAD = 'SETUP_RELOAD';
export const SETUP_SAVE = 'SETUP_SAVE';
export const SETUP_UPDATE = 'SETUP_UPDATE';
export const SETUP_USER_UPDATE = 'SETUP_USER_UPDATE';
export const SETUP_BOOKMARKS_UPDATE = 'SETUP_BOOKMARKS_UPDATE';
export const SETUP_START_LOADING = 'SETUP_START_LOADING';
export const SETUP_END_LOADING = 'SETUP_END_LOADING';
export const SETUP_LOCATION_STORE = 'SETUP_LOCATION_STORE';
